import React from 'react';

const SearchIcon = ({ size = 22, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2227 5.77821C8.21577 5.77821 5.77821 8.21577 5.77821 11.2227C5.77821 14.2295 8.21577 16.6671 11.2227 16.6671C14.2295 16.6671 16.6671 14.2295 16.6671 11.2227C16.6671 8.21577 14.2295 5.77821 11.2227 5.77821ZM4.22266 11.2227C4.22266 7.35666 7.35666 4.22266 11.2227 4.22266C15.0886 4.22266 18.2227 7.35666 18.2227 11.2227C18.2227 15.0886 15.0886 18.2227 11.2227 18.2227C7.35666 18.2227 4.22266 15.0886 4.22266 11.2227Z"
      fill={props?.stroke ? props?.stroke : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5833 16.5833C16.887 16.2795 17.3795 16.2795 17.6832 16.5833L19.5499 18.4499C19.8536 18.7537 19.8536 19.2462 19.5499 19.5499C19.2462 19.8536 18.7537 19.8536 18.4499 19.5499L16.5833 17.6832C16.2795 17.3795 16.2795 16.887 16.5833 16.5833Z"
      fill={props?.stroke ? props?.stroke : 'currentColor'}
    />
  </svg>
);

export default SearchIcon;
